export default [
    { index: 3, size: 5 },
    { index: 5, size: 30 },
    { index: 10, size: 30 },
    { index: 15, size: 15 },
    { index: 25, size: 20 }
];
